module.exports = __webpack_public_path__ + "img/1571246005.901179c6.jpg";